import { render, staticRenderFns } from "./ShowCharacter.vue?vue&type=template&id=64fa5960&scoped=true"
import script from "./ShowCharacter.vue?vue&type=script&lang=js"
export * from "./ShowCharacter.vue?vue&type=script&lang=js"
import style0 from "./ShowCharacter.vue?vue&type=style&index=0&id=64fa5960&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64fa5960",
  null
  
)

export default component.exports